import { render, staticRenderFns } from "./IconScissorsOutline.vue?vue&type=template&id=3db3aee0"
import script from "./IconScissorsOutline.vue?vue&type=script&lang=js"
export * from "./IconScissorsOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports